import {
  RotationForm,
  defaultRotationFormValues,
} from '../SetRotation/RotationForm'
import CommandModalTemplate from '../CommandModalTemplate'
import { ACBatteryRotationResults } from './ACBatteryRotationResults'
import { ResourceEnum } from 'api/dictionaries/rotation-excuses'

// 1st modal, 2nd modal heading
const modalTitles = {
  start: 'Set String Rotation',
  finish: 'Set String Rotation',
}
const queryName = 'setACRotation'
const label = 'AC Batteries'
const resourceType = ResourceEnum.string

// step 1 define custom input form returns jsx
// form validation passed from CommandModalTemplate
const userInputFormJsx = ({ ids, onUserInputFormChange, userInputForm }) =>
  RotationForm({
    ids,
    onUserInputFormChange,
    userInputForm,
    resourceType,
    label,
  })

// step 2 custom CommandResultsTemplate.jsx
const commandResultJsx = ({ ids, userInputForm }) => (
  <ACBatteryRotationResults ids={ids} userInputForm={userInputForm} />
)

// SetCommandModal keeps track of input form and each modal step, sending command, close modal
export const SetACBatteryRotationModal = ({ setShowCommandModal, ids }) => {
  return (
    <CommandModalTemplate
      ids={ids}
      setShowCommandModal={setShowCommandModal}
      modalTitles={modalTitles}
      defaultFormValues={defaultRotationFormValues}
      CommandResultJsx={commandResultJsx}
      UserInputFormJsx={userInputFormJsx}
      queryName={queryName}
      isFormValidated
    />
  )
}
